export var EMPTY_DRAFT_FIELD = '<p><br></p>';